import React from "react";
import SubHeader3 from '../../../resources/image/subHeader3_3.png';
import { connect } from "react-redux";
import MembershipReservationPopupContainer from "../../organisms/common/membershipReservationPopupContainer";
import { HeaderContainer } from "../../organisms/common/headerContainer";
import { SubHeader } from "../../molecules/subHeader";
import RestaurantReserveCompleteContainer from "../../organisms/esthetic/restaurantReserveCompleteContainer";
import MembershipCancelPopup from "../../organisms/common/membershipCancelPopup";

class RestaurantReserveCompleteTemplate extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer
          Label categoryLabel1={"予約完了"}
          categoryLabel2={"COMPLETE"}
          bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
          importedFlg={true}
          onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
        />
        <SubHeader SubImage={SubHeader3} />
        <MembershipReservationPopupContainer
          state={this.props.state}
          onClickClosePopupWindow={this.props.onClickClosePopupWindow}
          onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
        />
        <MembershipCancelPopup
          state={this.props.state}
          onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
        />
        <RestaurantReserveCompleteContainer />
      </div>
    );
  }
}

export default RestaurantReserveCompleteTemplate;